import { render, staticRenderFns } from "./schools.vue?vue&type=template&id=45e26da4&"
import script from "./schools.vue?vue&type=script&lang=js&"
export * from "./schools.vue?vue&type=script&lang=js&"
import style0 from "./schools.vue?vue&type=style&index=0&id=45e26da4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports